<template>
	<section class="margin-both-lg container margin-auto">
		<div class="inner">
			<h2 v-if="data.section_title" class="titler module-title margin-bottom-md">{{ data.section_title }}</h2>
			<div v-if="data.links" class="links-list">
				<template v-for="({ link, file, type }, k) in data.links">
					<ColorLink
						:class="linkType(link.url)"
						v-if="link && type === 'link'"
						:key="k"
						:link="link"
						uppercase
						icon
						color="black"
					/>
					<Button
						class="download"
						v-if="file && file.url && type === 'download'"
						:key="k"
						uppercase
						:outlined="false"
						has-icon
						color="black"
						link
					>
						<a :href="file.url" download>{{ file.filename }}</a>
					</Button>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
import Button from '@/components/elements/Button'
import ColorLink from '@/components/elements/ColorLink'
import { isExternal } from '@/helpers'

export default {
	name: 'link-buttons',
	props: ['data'],
	computed: {},
	methods: {
		linkType(link) {
			const home = window.WPVUE.home
			return !isExternal(link, home) ? 'internal' : 'external'
		},
	},
	components: {
		ColorLink,
		Button,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-links_block {
	.titler {
		margin-top: 0;
	}

	.fill-button {
		margin-bottom: 15px;
		display: block;
		width: 100%;
		text-align: left;
		a {
			display: block;
		}
		&:last-child {
			margin-bottom: 0 !important;
		}
	}
	@include mquery($phone) {
		.inner {
			margin-bottom: -10px;
		}
		.fill-button {
			margin-bottom: 10px;
		}
	}
}
</style>
